import React, { useState } from 'react';

const STEPS = ['Type', 'Pages', 'Options', 'Délai', 'Résumé'];

const TYPES = [
  { id:'vitrine',   label:'Site vitrine',    desc:'Présentation, services, contact',       base:1299 },
  { id:'portfolio', label:'Portfolio',        desc:'Galerie de travaux créatifs',            base:999  },
  { id:'ecom',      label:'E-commerce',      desc:'Boutique en ligne complète',             base:2499 },
  { id:'app',       label:'Application web', desc:'Espace membres & fonctions avancées',   base:3499 },
];

const PAGE_RANGES = [
  { id:'small',  label:'1–5 pages',  add:0   },
  { id:'medium', label:'6–10 pages', add:300 },
  { id:'large',  label:'10+ pages',  add:700 },
];

const FEATURES = [
  { id:'blog',       label:'Blog / Articles',     add:400 },
  { id:'galerie',    label:'Galerie / Portfolio',  add:200 },
  { id:'bilingue',   label:'Multilingue (FR/EN)',  add:350 },
  { id:'seo',        label:'SEO avancé',           add:500 },
  { id:'animations', label:'Animations premium',   add:450 },
  { id:'membres',    label:'Espace membres',       add:800 },
  { id:'crm',        label:'Intégration CRM',      add:600 },
];

const DELAYS = [
  { id:'standard', label:'Standard',     desc:'10–15 jours ouvrables', mult:1.00 },
  { id:'express',  label:'Express',      desc:'5–7 jours ouvrables',   mult:1.20 },
  { id:'urgent',   label:'Ultra-urgent', desc:'2–4 jours ouvrables',   mult:1.40 },
];

const s = {
  label:  { fontSize:'0.65rem', color:'#555', fontWeight:700, letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:8, display:'block' },
  btn:    { background:'#C8FF00', color:'#000', border:'none', padding:'11px 26px', borderRadius:10, fontWeight:800, fontSize:'0.88rem', cursor:'pointer' },
  outBtn: { background:'transparent', border:'1px solid rgba(255,255,255,0.1)', color:'#888', padding:'10px 20px', borderRadius:10, fontWeight:600, fontSize:'0.85rem', cursor:'pointer' },
  optCard: sel => ({
    background: sel ? 'rgba(200,255,0,0.07)' : 'rgba(255,255,255,0.02)',
    border: `1px solid ${sel ? 'rgba(200,255,0,0.3)' : 'rgba(255,255,255,0.07)'}`,
    borderRadius:12, padding:'16px 18px', cursor:'pointer', transition:'all 0.15s',
  }),
  row: { display:'flex', justifyContent:'space-between', padding:'12px 0', borderBottom:'1px solid rgba(255,255,255,0.05)' },
};

export default function QuoteCalculatorSection() {
  const [step, setStep]       = useState(0);
  const [type, setType]       = useState(null);
  const [pages, setPages]     = useState('small');
  const [features, setFeatures] = useState([]);
  const [delay, setDelay]     = useState('standard');

  const typeObj   = TYPES.find(t => t.id === type) || TYPES[0];
  const pagesObj  = PAGE_RANGES.find(p => p.id === pages);
  const delayObj  = DELAYS.find(d => d.id === delay);
  const featTotal = features.reduce((a, fid) => a + (FEATURES.find(f => f.id === fid)?.add || 0), 0);
  const subtotal  = (typeObj.base + (pagesObj?.add || 0) + featTotal);
  const total     = Math.round(subtotal * (delayObj?.mult || 1));
  const urgentExtra = total - subtotal;

  const toggle = id => setFeatures(p => p.includes(id) ? p.filter(f => f !== id) : [...p, id]);

  const reset = () => { setStep(0); setType(null); setPages('small'); setFeatures([]); setDelay('standard'); };

  return (
    <div style={{ animation:'fadeIn 0.3s ease' }}>
      {/* HEADER */}
      <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:32, flexWrap:'wrap', gap:16 }}>
        <div>
          <div style={{ fontSize:'0.65rem', color:'#555', fontWeight:700, letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:6 }}>Outil gratuit</div>
          <h2 style={{ fontSize:'1.6rem', fontWeight:900, color:'#EAEAEA', letterSpacing:'-0.03em', marginBottom:4 }}>Calculateur de devis</h2>
          <p style={{ color:'#555', fontSize:'0.85rem' }}>Estimez le coût d'un projet en 4 étapes.</p>
        </div>
        <div style={{ textAlign:'right' }}>
          <div style={{ fontSize:'2.4rem', fontWeight:900, color:'#C8FF00', letterSpacing:'-0.04em', fontVariantNumeric:'tabular-nums', lineHeight:1 }}>{total.toLocaleString()} $</div>
          <div style={{ fontSize:'0.7rem', color:'#444', marginTop:4 }}>Estimation · + tx</div>
        </div>
      </div>

      {/* PROGRESS BAR */}
      <div style={{ display:'flex', gap:6, marginBottom:28 }}>
        {STEPS.map((label, i) => (
          <div key={label} style={{ flex:1 }}>
            <div style={{ height:3, background: i <= step ? '#C8FF00' : 'rgba(255,255,255,0.06)', borderRadius:99, marginBottom:5, transition:'background 0.3s' }}/>
            <span style={{ fontSize:'0.6rem', color: i === step ? '#C8FF00' : '#2a2a2a', fontWeight:700, letterSpacing:'0.06em', textTransform:'uppercase' }}>{label}</span>
          </div>
        ))}
      </div>

      {/* CARD */}
      <div style={{ background:'#111', border:'1px solid rgba(255,255,255,0.07)', borderRadius:16, padding:'28px 28px' }}>

        {/* STEP 0 — Type */}
        {step === 0 && (
          <>
            <span style={s.label}>Type de projet</span>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:24 }}>
              {TYPES.map(t => (
                <div key={t.id} style={s.optCard(type === t.id)} onClick={() => setType(t.id)}>
                  <div style={{ fontWeight:800, color: type === t.id ? '#C8FF00' : '#EAEAEA', fontSize:'0.95rem', marginBottom:3 }}>{t.label}</div>
                  <div style={{ color:'#555', fontSize:'0.76rem', marginBottom:10 }}>{t.desc}</div>
                  <div style={{ fontWeight:900, color:'#C8FF00', fontSize:'1.05rem', fontVariantNumeric:'tabular-nums' }}>à partir de {t.base.toLocaleString()} $</div>
                </div>
              ))}
            </div>
            <div style={{ display:'flex', justifyContent:'flex-end' }}>
              <button style={{ ...s.btn, opacity: type ? 1 : 0.4 }} disabled={!type} onClick={() => setStep(1)}>Suivant →</button>
            </div>
          </>
        )}

        {/* STEP 1 — Pages */}
        {step === 1 && (
          <>
            <span style={s.label}>Nombre de pages</span>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10, marginBottom:24 }}>
              {PAGE_RANGES.map(p => (
                <div key={p.id} style={s.optCard(pages === p.id)} onClick={() => setPages(p.id)}>
                  <div style={{ fontWeight:800, color: pages === p.id ? '#C8FF00' : '#EAEAEA', fontSize:'1rem', marginBottom:5 }}>{p.label}</div>
                  <div style={{ color:'#555', fontSize:'0.78rem', fontVariantNumeric:'tabular-nums' }}>{p.add ? `+${p.add.toLocaleString()} $` : 'Inclus'}</div>
                </div>
              ))}
            </div>
            <div style={{ display:'flex', justifyContent:'space-between' }}>
              <button style={s.outBtn} onClick={() => setStep(0)}>← Retour</button>
              <button style={s.btn} onClick={() => setStep(2)}>Suivant →</button>
            </div>
          </>
        )}

        {/* STEP 2 — Features */}
        {step === 2 && (
          <>
            <span style={s.label}>Fonctionnalités optionnelles</span>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:24 }}>
              {FEATURES.map(f => (
                <div key={f.id} style={s.optCard(features.includes(f.id))} onClick={() => toggle(f.id)}>
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                    <span style={{ fontWeight:700, color: features.includes(f.id) ? '#C8FF00' : '#EAEAEA', fontSize:'0.88rem' }}>{f.label}</span>
                    <span style={{ fontSize:'0.76rem', color:'#555', fontVariantNumeric:'tabular-nums' }}>+{f.add.toLocaleString()} $</span>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ display:'flex', justifyContent:'space-between' }}>
              <button style={s.outBtn} onClick={() => setStep(1)}>← Retour</button>
              <button style={s.btn} onClick={() => setStep(3)}>Suivant →</button>
            </div>
          </>
        )}

        {/* STEP 3 — Delay */}
        {step === 3 && (
          <>
            <span style={s.label}>Délai de livraison</span>
            <div style={{ display:'flex', flexDirection:'column', gap:10, marginBottom:24 }}>
              {DELAYS.map(d => (
                <div key={d.id} style={s.optCard(delay === d.id)} onClick={() => setDelay(d.id)}>
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                    <div>
                      <div style={{ fontWeight:800, color: delay === d.id ? '#C8FF00' : '#EAEAEA', fontSize:'0.95rem', marginBottom:2 }}>{d.label}</div>
                      <div style={{ color:'#555', fontSize:'0.78rem' }}>{d.desc}</div>
                    </div>
                    <div style={{ fontWeight:700, color:'#888', fontSize:'0.85rem' }}>
                      {d.mult > 1 ? `+${Math.round((d.mult - 1) * 100)}%` : 'Standard'}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ display:'flex', justifyContent:'space-between' }}>
              <button style={s.outBtn} onClick={() => setStep(2)}>← Retour</button>
              <button style={s.btn} onClick={() => setStep(4)}>Voir le résumé →</button>
            </div>
          </>
        )}

        {/* STEP 4 — Summary */}
        {step === 4 && (
          <>
            <span style={s.label}>Résumé du projet</span>
            <div style={{ marginBottom:24 }}>
              <div style={s.row}>
                <span style={{ color:'#888' }}>{typeObj.label}</span>
                <span style={{ color:'#EAEAEA', fontWeight:700, fontVariantNumeric:'tabular-nums' }}>{typeObj.base.toLocaleString()} $</span>
              </div>
              {pagesObj?.add > 0 && (
                <div style={s.row}>
                  <span style={{ color:'#888' }}>{pagesObj.label}</span>
                  <span style={{ color:'#EAEAEA', fontWeight:700, fontVariantNumeric:'tabular-nums' }}>+{pagesObj.add.toLocaleString()} $</span>
                </div>
              )}
              {features.map(fid => {
                const f = FEATURES.find(f => f.id === fid);
                return f ? (
                  <div key={fid} style={s.row}>
                    <span style={{ color:'#888' }}>{f.label}</span>
                    <span style={{ color:'#EAEAEA', fontWeight:700, fontVariantNumeric:'tabular-nums' }}>+{f.add.toLocaleString()} $</span>
                  </div>
                ) : null;
              })}
              {delayObj?.mult > 1 && (
                <div style={s.row}>
                  <span style={{ color:'#888' }}>Livraison {delayObj.label} (+{Math.round((delayObj.mult - 1) * 100)}%)</span>
                  <span style={{ color:'#fbbf24', fontWeight:700, fontVariantNumeric:'tabular-nums' }}>+{urgentExtra.toLocaleString()} $</span>
                </div>
              )}
              <div style={{ display:'flex', justifyContent:'space-between', padding:'18px 0 4px' }}>
                <span style={{ color:'#EAEAEA', fontWeight:800, fontSize:'1rem' }}>Total estimé (+ tx)</span>
                <span style={{ color:'#C8FF00', fontWeight:900, fontSize:'1.5rem', fontVariantNumeric:'tabular-nums' }}>{total.toLocaleString()} $</span>
              </div>
            </div>
            <div style={{ display:'flex', gap:10, justifyContent:'space-between', flexWrap:'wrap' }}>
              <div style={{ display:'flex', gap:8 }}>
                <button style={s.outBtn} onClick={() => setStep(3)}>← Modifier</button>
                <button style={s.outBtn} onClick={reset}>Recalculer</button>
              </div>
              <a
                href={`mailto:info@ucreative.ca?subject=Demande de devis — ${typeObj.label}&body=Bonjour,%0A%0AJe souhaite obtenir un devis pour:%0A- Type: ${typeObj.label}%0A- Pages: ${pagesObj?.label}%0A- Options: ${features.map(fid => FEATURES.find(f=>f.id===fid)?.label).filter(Boolean).join(', ') || 'Aucune'}%0A- Délai: ${delayObj?.label}%0A- Estimation: ${total.toLocaleString()} $%0A%0AMon nom:%0AMon téléphone:`}
                style={{ ...s.btn, textDecoration:'none', display:'inline-flex', alignItems:'center', gap:6 }}
              >
                📧 Envoyer par courriel
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
